import React, { useRef, useState } from "react";
const MonterreyLandingAccordion = () => {
  const [reservationsOpen, setReservationsOpen] = useState(true);
  const [materialOpen, setMaterialOpen] = useState(false);
  const [studioOpen, setStudioOpen] = useState(false);

  const reservationsBtn = useRef();
  const materialBtn = useRef();
  const studioBtn = useRef();

  const handleToggle = () => {
    const reservationsValue =
      reservationsBtn.current.attributes["aria-expanded"].value === "true";
    const materialValue =
      materialBtn.current.attributes["aria-expanded"].value === "true";
    const studioValue =
      studioBtn.current.attributes["aria-expanded"].value === "true";

    setReservationsOpen(reservationsValue);
    setMaterialOpen(materialValue);
    setStudioOpen(studioValue);
  };

  const bgOpened = "#EEEEEE";
  const bgClosed = "#F9F9F9";

  return (
    <div className="accordion bg-white" id="accordionExample">
      <div className={`accordion-item border border-3 border-white`}>
        <h2 className={`accordion-header`}>
          <button
            ref={reservationsBtn}
            className={`accordion-button d-flex justify-content-between align-items-center
            ${reservationsOpen ? "accordion-opened " : "accordion-closed"}`}
            type="button"
            style={{
              borderBottomRightRadius: reservationsOpen && 0,
              borderBottomLeftRadius: reservationsOpen && 0,
            }}
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
            onClick={handleToggle}
          >
            <h2 className="bold ">Reservaciones</h2>
            <i
              className={`fas ${
                reservationsOpen ? "fa-minus" : "fa-plus"
              } accordion-btn-icon`}
            />
          </button>
        </h2>
        <div
          id="collapseOne"
          className={`accordion-collapse collapse show `}
          data-bs-parent="#accordionExample"
          style={{
            backgroundColor: reservationsOpen ? bgOpened : bgClosed,
          }}
        >
          <div className="accordion-body">
            <ul className="monterrey-accordion-list">
              <li>Puedes reservar hasta 1 hora antes de la clase.</li>
              <li>
                Puedes cancelar hasta 1 hora antes de la clase, si no el
                crédito será perdido.
              </li>
              <li>
                Para asegurar un buen inicio de clase, por favor se puntual.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="accordion-item border border-3 border-white">
        <h2 className="accordion-header">
          <button
            ref={materialBtn}
            onClick={handleToggle}
            className={`accordion-button d-flex justify-content-between align-items-center
            ${materialOpen ? "accordion-opened" : "accordion-closed"}`}
            type="button"
            style={{
              borderBottomRightRadius: materialOpen && 0,
              borderBottomLeftRadius: materialOpen && 0,
            }}
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            <h2 className="bold">Material</h2>

            <i
              className={`fas ${
                materialOpen ? "fa-minus" : "fa-plus"
              } accordion-btn-icon`}
            />
          </button>
        </h2>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <ul className="monterrey-accordion-list">
              <li>
                Las clases en mat se toman en calcetas. Te recomendamos usar
                calcetas antiderrapantes para mayor estabilidad y seguridad. No
                está permitido el uso de tenis sobre el mat. Si prefieres tomar
                tu clase con tenis, deberás traer tu propio tapete.
              </li>
              <li>
                Al terminar tu clase, desinfecta el mat y el equipo que hayas
                utilizado con las toallitas que te proporcionaremos y vuelve a
                colocarlo en su lugar tal como lo encontraste.
              </li>
              <li>
                Te pedimos cuidar el equipo y usarlo de forma adecuada para
                conservarlo en buen estado y mantener una mejor experiencia
                dentro del studio.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="accordion-item border border-white">
        <h2 className="accordion-header">
          <button
            ref={studioBtn}
            className={`accordion-button d-flex justify-content-between align-items-center
            ${studioOpen ? "accordion-opened" : "accordion-closed"}`}
            type="button"
            onClick={handleToggle}
            style={{
              borderBottomRightRadius: studioOpen && 0,
              borderBottomLeftRadius: studioOpen && 0,
            }}
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            <h2 className="bold">Estudio</h2>

            <i
              className={`fas ${
                studioOpen ? "fa-minus" : "fa-plus"
              } accordion-btn-icon`}
            />
          </button>
        </h2>
        <div
          id="collapseThree"
          className="accordion-collapse collapse"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <ul className="monterrey-accordion-list">
              <li>
                Durante la espera, mantén el silencio para no interrumpir la
                clase en curso.
              </li>
              <li>
                Para garantizar un entrenamiento cómodo y seguro, te pedimos
                que respetes el espacio asignado. Evita mover los materiales de
                tus compañeras y mantén tu área organizada.
              </li>
              <li>
                Las llamadas dentro del salón están prohibidas. Si necesitas
                tomar una llamada, puedes hacerlo en front desk o fuera del
                estudio.
              </li>
              <li>
                La entrada al salón de niños menores de 13 años está restringida
                por seguridad. En caso necesario, podrán esperar en front desk.
              </li>
              <li>
                Contamos con regadera equipada con shampoo, acondicionador, gel
                y crema corporal. Trae tu toalla y el resto de tus productos de
                higiene personal.
              </li>
              <li>
                Objetos olvidados: repórtalos en recepción. Serán resguardados
                por 2 semanas. Después de ese plazo, los objetos no reclamados
                serán desechados.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonterreyLandingAccordion;
